import { Input as InputBase } from './Input';
import { InputPassword } from './_Password/InputPassword';
import { InputPhone } from './_Phone/InputPhone';
import { IInputProps as IInputPropsBase } from './models';

interface INestedComponents {
  Password: typeof InputPassword;
  Phone: typeof InputPhone;
}

export const Input = InputBase as unknown as React.ForwardRefExoticComponent<
  IInputPropsBase & React.RefAttributes<HTMLInputElement>
> &
  INestedComponents;

Input.Password = InputPassword;
Input.Phone = InputPhone;

export type IInputProps = IInputPropsBase;
